export default __webpack_public_path__ + "static/media/amm.09c557e6.svg";